import React from 'react'
import { ExperianReportContainer } from 'containers/Integrations/Reports/ExperianReportContainer'

export const ExperianReportPage = () => <ExperianReportContainer />
